import { ASSIGNED_ADVISOR_LOOKUP_KINDS } from 'cpool-constants';
import type { Resolver } from 'cpool-schemas';
import { schemaId, schemaUserCommon } from 'cpool-schemas';
import { z } from 'zod';

import { schemaAssignedAdvisorFound, schemaAssignedAdvisorNone } from './shared/assignedAdvisor';

type Arguments = {
    ownerId: string | null;
};

export const schemaUserResolver_GetAssignedAdvisorForOwner = z.discriminatedUnion('kind', [
    schemaAssignedAdvisorFound,
    schemaAssignedAdvisorNone,
    z.object({
        candidateIds: z.array(schemaId).min(2),
        kind: z.literal(ASSIGNED_ADVISOR_LOOKUP_KINDS.AMBIGUOUS),
        pid: schemaUserCommon.shape.pid.unwrap().unwrap(),
    }),
]);

export type SchemaUserResolver_GetAssignedAdvisorForOwner = z.infer<
    typeof schemaUserResolver_GetAssignedAdvisorForOwner
>;

export type UserResolver_GetAssignedAdvisorForOwner = Resolver<
    Arguments,
    SchemaUserResolver_GetAssignedAdvisorForOwner
>;
